import { RelodeApiError } from "../../";

import { INote } from "./types/INote";
import {
    createAction,
    ActionsUnion,
} from "../../components/reducer/actionHelpers";

export enum noteActionNames {
    LOAD_NOTES = "LOAD_NOTES",
    LOAD_NOTES_SUCCESS = "LOAD_NOTES_SUCCESS",
    LOAD_NOTES_FAILURE = "LOAD_NOTES_FAILURE",
    ADD_NOTE = "ADD_NOTE",
    SET_CURRENT_NOTE_CONTEXT = "SET_CURRENT_NOTE_CONTEXT",
    SET_NOTE_IS_DIRTY = "SET_NOTE_IS_DIRTY",
}

export const noteActionCreators = {
    loadNotes: (userId: number, jobId?: number) =>
        createAction(noteActionNames.LOAD_NOTES, { userId, jobId }),
    loadNotesSuccess: (notes: INote[]) =>
        createAction(noteActionNames.LOAD_NOTES_SUCCESS, { notes }),
    loadNotesFailure: (error: RelodeApiError) =>
        createAction(noteActionNames.LOAD_NOTES_FAILURE, { error }),
    addNote: (note: INote) => createAction(noteActionNames.ADD_NOTE, { note }),
    setCurrentNoteContext: (noteContext: string) =>
        createAction(noteActionNames.SET_CURRENT_NOTE_CONTEXT, { noteContext }),
    setIsDirty: (isDirty: boolean) =>
        createAction(noteActionNames.SET_NOTE_IS_DIRTY, { isDirty }),
};

export type NoteActionTypes = ActionsUnion<typeof noteActionCreators>;
